import React from "react";

export const ChipsCustom = ({ selected, children, onClick }) => {
  return (
    <div
      className={`
        py-ride-gl-spacing-large 
        px-ride-gl-spacing-xlarge 
        rounded-ride-sys-border-radius-container-medium
        cursor-pointer
        flex
        items-center
        lg:px-ride-gl-spacing-2xlarge
        ${
          selected
            ? "border-2 border-ride-sys-color-border-extreme bg-ride-sys-color-surface-extreme text-ride-sys-color-text-inverse"
            : "border-2 border-ride-sys-color-border-extreme"
        }
      `}
      onClick={onClick}
    >
      <span className="ride-sys-text-label-medium-default lg:ride-sys-text-paragraph-large-bold-short">{children}</span>
    </div>
  );
};
